import React from "react";
import { Row, Col } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import StatsKpiCard from "./StatsKpiCard";
import { formatGnf, STATS_COLORS, doughnutChartOptions } from "./statsChartSetup";

const StatsTabSynthese = ({ data }) => {
  if (!data) return null;
  const { kpis, comparatif, total_contrats_actifs, jours_conges_pris } = data;
  const netTotal = kpis.tous.salaire_net_total || 0;
  const pctV = comparatif.pct_net_verrouille || 0;
  const pctO = comparatif.pct_net_non_verrouille || 0;

  const doughnutData = {
    labels: ["Verrouillé", "Non verrouillé"],
    datasets: [
      {
        data: [kpis.verrouilles.salaire_net_total, kpis.non_verrouilles.salaire_net_total],
        backgroundColor: [STATS_COLORS.success, STATS_COLORS.warning],
        borderWidth: 0,
        hoverOffset: 8,
      },
    ],
  };

  return (
    <div className="stats-tab-content">
      <Row className="g-3 mb-4">
        <Col sm={6} lg={3}>
          <StatsKpiCard
            label="Salaire net (période filtrée)"
            value={formatGnf(kpis.tous.salaire_net_total)}
            unit="GNF"
            variant="primary"
            sub={`${kpis.tous.nb_employes} employé(s) · ${kpis.tous.nb_lignes} ligne(s)`}
          />
        </Col>
        <Col sm={6} lg={3}>
          <StatsKpiCard
            label="Net moyen / employé"
            value={formatGnf(kpis.tous.salaire_net_moyen)}
            unit="GNF"
            variant="indigo"
          />
        </Col>
        <Col sm={6} lg={3}>
          <StatsKpiCard
            label="Contrats actifs"
            value={total_contrats_actifs}
            variant="slate"
          />
        </Col>
        <Col sm={6} lg={3}>
          <StatsKpiCard
            label="Congés pris"
            value={jours_conges_pris}
            unit="jours"
            variant="cyan"
          />
        </Col>
      </Row>

      <Row className="g-3">
        <Col lg={8}>
          <div className="stats-panel">
            <h6 className="stats-panel-title">Répartition du masse salariale nette</h6>
            <Row className="g-3 align-items-center">
              <Col md={5}>
                <div className="stats-chart-box stats-chart-doughnut">
                  <Doughnut
                    data={doughnutData}
                    options={{
                      ...doughnutChartOptions,
                      plugins: {
                        ...doughnutChartOptions.plugins,
                        legend: {
                          ...doughnutChartOptions.plugins.legend,
                          position: "bottom",
                        },
                        tooltip: {
                          ...doughnutChartOptions.plugins.tooltip,
                          callbacks: {
                            label: (ctx) => `${ctx.label}: ${formatGnf(ctx.raw)} GNF`,
                          },
                        },
                      },
                    }}
                  />
                  <div className="stats-doughnut-center">
                    <span className="stats-doughnut-label">Total net</span>
                    <strong>{formatGnf(netTotal)}</strong>
                  </div>
                </div>
              </Col>
              <Col md={7}>
                <div className="stats-split-bars">
                  <div className="stats-split-row">
                    <span className="stats-split-label">
                      <span className="dot dot-success" /> Verrouillé
                    </span>
                    <span className="stats-split-value">{formatGnf(kpis.verrouilles.salaire_net_total)} GNF</span>
                    <span className="stats-split-pct">{pctV}%</span>
                  </div>
                  <div className="stats-progress">
                    <div className="stats-progress-fill success" style={{ width: `${pctV}%` }} />
                  </div>
                  <div className="stats-split-row mt-3">
                    <span className="stats-split-label">
                      <span className="dot dot-warning" /> Non verrouillé
                    </span>
                    <span className="stats-split-value">{formatGnf(kpis.non_verrouilles.salaire_net_total)} GNF</span>
                    <span className="stats-split-pct">{pctO}%</span>
                  </div>
                  <div className="stats-progress">
                    <div className="stats-progress-fill warning" style={{ width: `${pctO}%` }} />
                  </div>
                </div>
                <p className="stats-hint mt-3 mb-0">
                  Les montants « verrouillés » correspondent aux périodes validées (bulletin figé).
                  Les « non verrouillés » peuvent encore être modifiés.
                </p>
              </Col>
            </Row>
          </div>
        </Col>
        <Col lg={4}>
          <div className="stats-panel h-100">
            <h6 className="stats-panel-title">Périodes de paie</h6>
            <div className="stats-mini-grid">
              <div className="stats-mini-item">
                <span className="n">{kpis.tous.nb_periodes}</span>
                <span className="l">Périodes distinctes</span>
              </div>
              <div className="stats-mini-item success">
                <span className="n">{kpis.tous.nb_periodes_verrouillees}</span>
                <span className="l">Verrouillées</span>
              </div>
              <div className="stats-mini-item warning">
                <span className="n">{kpis.tous.nb_periodes_ouvertes}</span>
                <span className="l">Ouvertes</span>
              </div>
              <div className="stats-mini-item accent">
                <span className="n">{kpis.recents.nb_lignes}</span>
                <span className="l">Lignes récentes</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StatsTabSynthese;
